import request from "@/utils/request"
// 网页二维码支付
export const paysend = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/pay/paysend",
    });
};
//支付回调
export const paylist = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/paylist",
    });
};

export const getamount = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/pay/get_amount",
    });
};
export const notifyurl = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/pay/notify_url",
    });
};
//pc网关支付
export const pcpay = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/pay/pc_pay",
    });
};
// 支付信息提交
export const bhpay = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/Baohan/bhpay",
    });
};
// 下载文件
export const snfiledown= (dat) => {
    return request({
      method: "POST",
      url: "tripartite/mobile/baohan/snfiledown",
      data: {
       ...dat
      },
    });
  };

  // 个人认证
export const renzhenggeren = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/index/renzheng_geren",
    });
};
  // 个人身份证识别
  export const idcard = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/index/idcard",
    });
};
  // 个人认证
  export const rzchaxun = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/index/rzchaxun",
    });
};
  // 添加地址
  export const addaddress = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/address/addaddress",
    });
};
// /handle/address/deladdress
  // 删除地址
  export const deladdress = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/address/deladdress",
    });
};
  // 编辑地址
  export const saveaddress = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/address/saveaddress",
    });
};


// WEBPACK FOOTER //
// ./src/api/xin.js